import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ProjectCard from './components/ProjectCard';
import { useRouter } from 'next/router';
import Slider from '../../../../../new-components/Slider';
import { LaunchDTO } from '../../dtos/response.dtos';

interface TrendingProjectsProps {
  trendingProjects: LaunchDTO[];
}

interface ContainerProps {
  isMobile: boolean;
  locale?: string;
}

const TrendingProjects = ({ trendingProjects }: TrendingProjectsProps) => {
  const { t } = useTranslation('launches');

  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { locale } = useRouter();

  const getSliderChildren = () => {
    return trendingProjects.map(project => (
      <ProjectCard
        key={project.slug}
        name={project.name}
        slug={project.slug}
        area={project.areaName}
        price={{
          amount: project.minPrice,
          currency: project.currency
        }}
        image={project.imageUrl}
      />
    ));
  };

  const trendingProjectsSliderProps = {
    width: '445px',
    height: '353px',
    slidesPerView: 'auto' as 'auto',
    spaceBetweenSlides: 16,
    slidesPerGroup: 1,
    children: getSliderChildren()
  };

  return (
    <Container id="trending-projects" locale={locale} isMobile={isMobile}>
      <div className="header">
        <h2>{t('trending_projects')}</h2>
      </div>

      {isMobile ? (
        <div className="projects-cards">
          {trendingProjects.map(project => (
            <ProjectCard
              key={project.slug}
              name={project.name}
              slug={project.slug}
              area={project.areaName}
              price={{
                amount: project.minPrice,
                currency: project.currency
              }}
              image={project.imageUrl}
            />
          ))}
        </div>
      ) : (
        <Slider {...trendingProjectsSliderProps} />
      )}
    </Container>
  );
};

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 16px;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    h2 {
      color: #00324c;
      font-size: 24px;
      font-family: materialBold;
      text-transform: capitalize;

      @media screen and (max-width: ${props =>
          props.theme.breakPoints.mobile.max}) {
        color: #2c3138;
        font-size: ${props => props.theme.font.sizes.xxl};
      }
    }

    .show-all {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #015c9a;
      font-family: materialRegular;
      font-size: ${props => props.theme.font.sizes.xl};
      text-transform: capitalize;
      text-decoration: underline;
      background-color: transparent;
    }
  }

  .projects-cards {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    .projects-cards {
      width: 100%;
      overflow-x: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }
`;

export default TrendingProjects;
